import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'

import Navbar from './Navbar'
import BackToTopButton from './BackToTopButton'
import Footer from './Footer'

import { base } from 'lib/themes'

const Layout = (props) => (
  <ThemeProvider theme={base}>
    <CssBaseline />

    <Navbar navigation={props.navigation} homeHref={props.homeHref} showLogo={props.showLogo} navbarBackgroundColor={props.navbarBackgroundColor} />
    {props.children}
    <BackToTopButton />
    <Footer />
  </ThemeProvider>
)

export default Layout
